import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutLateRouteStatusList extends Layout {
    layoutheaderLateRouteStatusCodes: LayoutHeader;
    sourceLateRouteStatus: DataSource;
    tableLateRouteStatusCodes: Table;
}
